import React from 'react'
import MyPayroll from './MyPayroll'

export default function StudentsReport() {
  return (
    <div>
      <MyPayroll />
    </div>
  )
}
